module.exports = "https://coursera_assets.s3.amazonaws.com/images/f8b4b563fb6f482a0ace43503559aac3.png";